import styled from '@emotion/styled';

type DashboardOptionCardProps = {
  optionKey: string;
  label: string;
  logo: React.ReactNode;
  isSelected: boolean;
  onSelect: (key: string) => void;
};

const CardContainer = styled.div<{ isSelected: boolean }>(({ isSelected, theme }) => ({
  flex: '1 1 0',
  minWidth: 150,
  maxWidth: 200,
  border: `2px solid var(--gray-xl)`,
  backgroundColor: isSelected ? theme.palette.select.item.focused.backgroundColor : '#fff',
  borderRadius: 10,
  padding: '24px 12px 18px 12px',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  transition: 'border-color 0.2s, background 0.2s',
  position: 'relative',
  '&:hover': {
    borderColor: 'var(--gray-xl)',
  },
}));

const RadioRow = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
  marginBottom: 10,
});

const Radio = styled.span<{ isSelected: boolean }>(({ isSelected, theme }) => ({
  width: 22,
  height: 22,
  border: `2px solid var(--gray-xl)`,
  borderRadius: '50%',
  background: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'border-color 0.2s',
  ...(isSelected && {
    '&::after': {
      content: '""',
      width: 12,
      height: 12,
      background: theme.palette.select.item.focused.backgroundColor,
      borderRadius: '50%',
    },
  }),
}));

const Logo = styled.div({
  margin: '10px 0 12px 0',
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const Label = styled.div({
  fontFamily: 'var(--font-semibold)',
  fontSize: 18,
  textAlign: 'center',
  marginTop: 4,
});

export const DashboardOptionCard = ({
  optionKey,
  label,
  logo,
  isSelected,
  onSelect,
}: DashboardOptionCardProps) => {
  return (
    <CardContainer
      isSelected={isSelected}
      onClick={() => onSelect(optionKey)}
      tabIndex={0}
      role="button"
      aria-pressed={isSelected}>
      <RadioRow>
        <Radio isSelected={isSelected} />
      </RadioRow>
      <Logo>{logo}</Logo>
      <Label>{label}</Label>
    </CardContainer>
  );
};
